export default {
    getMainPageContents(state) {
        return state.mainPageContent;
    },
    getRightSideLinks(state) {
        return state.rightSideLinks;
    }
}
